module.exports = __webpack_public_path__ + "fonts/Jujuna-Regular.9e3ee04e.ttf";